import { toCx } from '../../../classname.js';

var spacingStyleMapper = {
  m: function m(_m, _) {
    return {
      classNames: [toCx('m', _m)]
    };
  },
  mb: function mb(_mb, _) {
    return {
      classNames: [toCx('mb', _mb)]
    };
  },
  me: function me(_me, _ref) {
    var isLtr = _ref.isLtr;
    return {
      classNames: [toCx(isLtr ? 'mr' : 'ml', _me)]
    };
  },
  ms: function ms(_ms, _ref2) {
    var isLtr = _ref2.isLtr;
    return {
      classNames: [toCx(isLtr ? 'ml' : 'mr', _ms)]
    };
  },
  mt: function mt(_mt, _) {
    return {
      classNames: [toCx('mt', _mt)]
    };
  },
  mx: function mx(_mx, _) {
    return {
      classNames: [toCx('mx', _mx)]
    };
  },
  my: function my(_my, _) {
    return {
      classNames: [toCx('my', _my)]
    };
  },
  p: function p(_p, _) {
    return {
      classNames: [toCx('p', _p)]
    };
  },
  pb: function pb(_pb, _) {
    return {
      classNames: [toCx('pb', _pb)]
    };
  },
  pe: function pe(_pe, _ref3) {
    var isLtr = _ref3.isLtr;
    return {
      classNames: [toCx(isLtr ? 'pr' : 'pl', _pe)]
    };
  },
  ps: function ps(_ps, _ref4) {
    var isLtr = _ref4.isLtr;
    return {
      classNames: [toCx(isLtr ? 'pl' : 'pr', _ps)]
    };
  },
  pt: function pt(_pt, _) {
    return {
      classNames: [toCx('pt', _pt)]
    };
  },
  px: function px(_px, _) {
    return {
      classNames: [toCx('px', _px)]
    };
  },
  py: function py(_py, _) {
    return {
      classNames: [toCx('py', _py)]
    };
  }
};

export { spacingStyleMapper };
//# sourceMappingURL=spacing.js.map
